import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

/** Mount overlays on document.body so they cover the Shell header. */
export default function OverlayPortal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return children
  return createPortal(children, document.body)
}
